import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgInstagramIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M18.805.192C15.4.347 13.074.89 11.038 1.68c-2.104.818-3.888 1.912-5.667 3.69-1.779 1.78-2.874 3.564-3.691 5.668C.889 13.074.348 15.4.192 18.805.037 22.218 0 23.308 0 31.998s.037 9.78.192 13.193c.156 3.406.697 5.732 1.488 7.767.818 2.105 1.912 3.888 3.69 5.667 1.78 1.779 3.565 2.873 5.668 3.691 2.036.791 4.362 1.333 7.767 1.488 3.413.155 4.503.192 13.193.192s9.78-.037 13.193-.192c3.406-.155 5.731-.697 7.767-1.488 2.105-.818 3.888-1.912 5.667-3.69 1.779-1.78 2.873-3.565 3.691-5.668.791-2.035 1.333-4.362 1.488-7.767.155-3.413.192-4.503.192-13.193s-.037-9.78-.192-13.193c-.155-3.406-.697-5.731-1.488-7.767-.818-2.104-1.912-3.888-3.69-5.667-1.78-1.779-3.565-2.873-5.668-3.691C50.923.889 48.596.347 45.19.192 41.778.037 40.688 0 31.998 0s-9.78.037-13.193.192Zm.263 57.85c-3.12-.142-4.814-.662-5.942-1.1-1.494-.582-2.56-1.274-3.68-2.394-1.119-1.12-1.813-2.185-2.392-3.68-.44-1.127-.96-2.82-1.102-5.941-.154-3.374-.186-4.386-.186-12.93s.032-9.556.186-12.93c.142-3.12.663-4.815 1.102-5.942.58-1.494 1.273-2.56 2.393-3.68 1.12-1.12 2.185-1.813 3.68-2.393 1.127-.438 2.82-.959 5.941-1.101 3.374-.153 4.386-.186 12.93-.186s9.556.032 12.93.186c3.12.142 4.815.663 5.942 1.101 1.494.581 2.56 1.274 3.68 2.393 1.12 1.12 1.813 2.186 2.393 3.68.438 1.127.959 2.821 1.101 5.942.154 3.374.186 4.386.186 12.93s-.032 9.556-.186 12.93c-.142 3.12-.663 4.814-1.101 5.942-.581 1.494-1.274 2.56-2.393 3.68-1.12 1.119-2.186 1.813-3.68 2.392-1.127.439-2.822.96-5.942 1.102-3.374.154-4.386.186-12.93.186s-9.556-.032-12.93-.186Zm26.17-43.124a3.84 3.84 0 1 0 7.68 0 3.839 3.839 0 1 0-7.68 0Zm-29.671 17.08c0 9.075 7.356 16.431 16.431 16.431 9.075 0 16.431-7.356 16.431-16.431 0-9.075-7.356-16.431-16.43-16.431-9.076 0-16.432 7.356-16.432 16.431Zm5.765 0c0-5.89 4.776-10.666 10.666-10.666 5.89 0 10.667 4.774 10.667 10.666 0 5.89-4.776 10.667-10.667 10.667-5.89 0-10.666-4.775-10.666-10.667Z"
      fill="currentColor"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgInstagramStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgInstagramIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const InstagramIcon: any = SvgInstagramStyle;
export default InstagramIcon;
